import axiosInstance from "../../axiosInstance";

const BASE_URL = "/elearning/attendance";

/**
 * @param {string} date YYYY-MM-DD
 * @param {{ venue?: 'all'|'center'|'school', branch_id?: string }} opts
 */
export const getAttendanceClasses = async (date, opts = {}) => {
  try {
    const params = {
      date: date || new Date().toISOString().slice(0, 10),
    };
    if (opts.venue && opts.venue !== "all") params.venue = opts.venue;
    if (opts.branch_id && opts.branch_id !== "all") params.branch_id = opts.branch_id;

    const res = await axiosInstance.get(`${BASE_URL}/classes`, { params });
    const data = res.data || {};
    return {
      records: data.records || [],
      meta: data.meta || {},
    };
  } catch (error) {
    console.error("Lỗi lấy danh sách lớp điểm danh:", error);
    throw error;
  }
};

export const getAttendanceSheet = async (classId, date) => {
  try {
    const res = await axiosInstance.get(
      `${BASE_URL}/classes/${classId}/sheet`,
      {
        params: { date: date || new Date().toISOString().slice(0, 10) },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Lỗi lấy phiếu điểm danh:", error);
    throw error;
  }
};

export const saveAttendanceSheet = async (payload) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/sheet`, payload);
    return res.data;
  } catch (error) {
    console.error("Lỗi lưu điểm danh:", error);
    throw error;
  }
};

/** @param {object} params query
 *  @param {{ silent?: boolean }} [options] silent: không hiện toast lỗi toàn cục (dùng khi API phụ) */
export const getAttendanceHistory = async (params = {}, options = {}) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/history`, {
      params,
      skipGlobalErrorToast: Boolean(options.silent),
    });
    return res.data;
  } catch (error) {
    console.error("Lỗi lấy lịch sử điểm danh:", error);
    throw error;
  }
};

export const updateAttendanceRemark = async (id, staff_remark) => {
  try {
    const res = await axiosInstance.patch(
      `${BASE_URL}/history/${id}`,
      { staff_remark }
    );
    return res.data;
  } catch (error) {
    console.error("Lỗi cập nhật ghi chú:", error);
    throw error;
  }
};

export const addStudentToClass = async (class_id, student_id) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/enrollment`, {
      class_id,
      student_id,
    });
    return res.data;
  } catch (error) {
    console.error("Lỗi thêm học viên vào lớp:", error);
    throw error;
  }
};

/** Báo cáo chuyên cần: view=classes|students + year_month / course_id / class_id */
export const getAttendanceReport = async (params = {}) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/report`, { params });
    return res.data;
  } catch (error) {
    console.error("Lỗi lấy báo cáo điểm danh:", error);
    throw error;
  }
};
